/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Tea_Grade_Stock_Lot_CountInputs */

const vi_tea_grade_stock_lot_count = /** @type {(inputs: Tea_Grade_Stock_Lot_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} bao (lô còn tồn)`)
};

/**

* @param {Tea_Grade_Stock_Lot_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_grade_stock_lot_count = /** @type {((inputs: Tea_Grade_Stock_Lot_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Grade_Stock_Lot_CountInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_grade_stock_lot_count(inputs)
});